import api from './api';

export interface ShowcaseAnalyticsSummary {
  period: { date_from: string; date_to: string };
  totals: {
    visitors: number;
    sessions: number;
    page_views: number;
    vehicle_views: number;
    whatsapp_clicks: number;
    shares: number;
    online_now: number;
  };
  daily: { date: string; visitors: number; page_views: number; whatsapp_clicks: number }[];
  top_vehicles: {
    vehicle_id: number;
    brand: string | null;
    model: string | null;
    year: string | null;
    status: string;
    sale_price: number | null;
    views: number;
    unique_visitors: number;
    whatsapp_clicks: number;
    shares: number;
  }[];
  cities: { city: string; region: string | null; country: string | null; visitors: number }[];
  regions: { region: string; country: string | null; visitors: number }[];
  sources: { source: string; sessions: number }[];
  devices: { device_type: string; visitors: number }[];
}

const showcaseAnalyticsService = {
  async getSummary(dateFrom: string, dateTo: string): Promise<ShowcaseAnalyticsSummary> {
    const response = await api.get<ShowcaseAnalyticsSummary>('/showcase-analytics', {
      params: { date_from: dateFrom, date_to: dateTo },
    });
    return response.data;
  },
};

export default showcaseAnalyticsService;
